import React from 'react';
import { CompactPicker } from 'react-color';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import Popover from '@mui/material/Popover';

export default function SchoolColorPicker(props) {
    const school = props.school
    const handleChangeComplete = props.handleChangeComplete

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <React.Fragment>
            <Tooltip title="Change color" placement="right">
                <Button
                    onClick={handleClick}
                    sx={{
                        borderRadius: "4px",
                        border: 1,
                        width: "16px",
                        minWidth: "16px",
                        height: "18px",
                        maxHeight: "16px",
                        backgroundColor: "white",
                        "&:hover": { opacity: 0.8 }
                    }}
                >
                </Button>
            </Tooltip>
            <Popover
                id={`${school}-color-picker`}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                sx={{ marginLeft: "24px", boxShadow: 1 }}
            >
                <CompactPicker
                    onChangeComplete={(e) => handleChangeComplete(e)}
                />
            </Popover>
        </React.Fragment>


    )
}
